import { IRootState } from '../../../store'
import { ICustomFluidOptions } from '../store/options.types'

export const getCustomFluidsOptionsSelector = (state: IRootState): ICustomFluidOptions =>
  state.options.customFluidsOptions
